// extracted by mini-css-extract-plugin
export default {"familyBrand":"styles_familyBrand__ihx6C","brands":"styles_brands__IwXli","subtitle":"styles_subtitle__ljf1a","groupBrands":"styles_groupBrands__Gwj1d"};